export default __webpack_public_path__ + "static/dale-banner-face-8288c4bc0fea45d197f2941549c2993c.jpg";